<div class="product-avatar fxRow fxRowCenter fxColumnCenter shadowPrimary" [ngStyle]="style" [class.product-avatar-src]="src">
    <svg-icon *ngIf="!src" class="product-avatar-icon" src="./assets/image/icon/shop/product/product-avatar-icon.svg"
              [style.width.px]="iconSize" [style.height.px]="iconSize"></svg-icon>
    <img *ngIf="src" [src]="src" [draggable]="false" (error)="src = null" />
</div>
